import ContentCopyIcon from '@mui/icons-material/ContentCopy'
import { TextInput } from '../text-input'
import { IconButton, Link } from '@mui/material'
import { LinkIcon } from 'src/assets/icons'
import { useTranslation } from 'react-i18next'
import { useStyles } from './styles'
import { ETranslationNs } from 'src/types'
import { useCopy } from 'src/hooks'

export const XAccountHolder = () => {
  const xAccountName = process.env.REACT_APP_X_ACCOUNT
  const xAccountUrl = `https://x.com/${xAccountName}`

  const [t] = useTranslation(ETranslationNs.Form)
  const classes = useStyles()
  const handleCopy = useCopy(xAccountUrl)
  return (
    <>
      {xAccountName ? (
        <div className={classes.holder}>
          <TextInput
            fullWidth={false}
            inputPlaceholder=""
            disabled
            inputUpperLabel={t('x-account-url-label.v')}
            value={xAccountUrl}
            fontSize={11}
            endIcon={
              <div className={classes.iconsWrapper}>
                <IconButton
                  disabled={!xAccountUrl}
                  size="small"
                  component={Link}
                  href={xAccountUrl}
                  target="_blank"
                >
                  <LinkIcon className={classes.copyIcon} />
                </IconButton>

                <IconButton size="small" disabled={!xAccountUrl} onClick={handleCopy}>
                  <ContentCopyIcon className={classes.copyIcon} />
                </IconButton>
              </div>
            }
          />
        </div>
      ) : null}
    </>
  )
}
